<script setup>
import DatetimeFilter from "@/components/MapPage/MapNavbar/Filters/DatetimeFilter.vue";
import {computed, defineEmits, inject} from "vue";
import {useRubricsStore} from "@/store/NewsFeed/rubrics";
import { useBlockStore } from "@/store/NewsFeed/blocks";
import BlockFilter from "@/components/MapPage/MapNavbar/Filters/BlockFilter.vue";

const emit = defineEmits(["update-filter", "close-news-list", "set-active-map"]);

const blockStore = useBlockStore();
const rubricStore = useRubricsStore();

const selectedTheme = inject("selectedTheme");
const selectedRubric = inject("selectedRubric");


const toggleTheme = () => {
  // Добавление рубрик из выбранных тем
  const rubricsIds = selectedTheme.value
      .map((theme) => theme.rubric_ids).reduce((acc, rubricsIds) => [...acc, ...rubricsIds], []);
  const newRubricList = rubricList.value.filter((rubric) => rubricsIds.includes(rubric.id));

  selectedRubric.value = [];

  for (const rubric of newRubricList) {
    toggleRubric(rubric);
  }

  emit("update-filter");
};

const toggleRubric = (item) => {
  if (Array.isArray(item)) {
    item.length === selectedRubric.value.length ? selectedRubric.value = [] : selectedRubric.value = [...item];
  } else {
    const isChecked = selectedRubric.value.filter((selectedItem) => selectedItem === item);
    if (isChecked.length > 0) {
      selectedRubric.value.splice(selectedRubric.value.indexOf(isChecked[0]), 1);
    } else {
      selectedRubric.value.push(item);
    }
  }

  emit("update-filter");
};

const updateFilter = () => {
  emit("update-filter");
};

const themeList = computed(() => [...blockStore.allThemes]);
const rubricList = computed(() => [...rubricStore.allRubrics.filter((rubric) => rubric.is_fixed)]);

</script>

<template>
  <div class="map-filter">
    <DatetimeFilter @update-filter="emit('update-filter')" />

    <BlockFilter
      v-model="selectedTheme"
      :items="themeList"
      type="block"
      @update:model-value="toggleTheme"
    />
    <BlockFilter
      v-model="selectedRubric"
      :items="rubricList"
      type="rubric"
      @update:model-value="updateFilter"
    />
  </div>
</template>